import TransportadoraEmailService from "@/services/TransportadoraEmailService";

export const transportadoraEmail = {
  namespaced: true,
  state: {
    transportadoraEmail: {},
  },
  actions: {
    getTransportadoraEmail({ commit }, payload) {
      return TransportadoraEmailService.GetTransportadoraEmail(payload).then(
        (transportadoraEmail) => {
          return Promise.resolve(transportadoraEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTransportadoraEmail({ commit }, payload) {
      return TransportadoraEmailService.PostTransportadoraEmail(payload).then(
        (transportadoraEmail) => {
          return Promise.resolve(transportadoraEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTransportadoraEmail({ commit }, payload) {
      return TransportadoraEmailService.PutTransportadoraEmail(payload).then(
        (transportadoraEmail) => {
          return Promise.resolve(transportadoraEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTransportadoraEmail({ commit }, payload) {
      return TransportadoraEmailService.DeleteTransportadoraEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTransportadoraEmailOData({ commit }, payload) {
      return TransportadoraEmailService.GetTransportadoraEmailOData(
        payload
      ).then(
        (transportadoraEmail) => {
          return Promise.resolve(transportadoraEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default transportadoraEmail;
